import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=037d9437&scoped=true&"
import script from "./alert.vue?vue&type=script&lang=ts&"
export * from "./alert.vue?vue&type=script&lang=ts&"
import style0 from "./alert.vue?vue&type=style&index=0&id=037d9437&lang=scss&module=true&scoped=true&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./alert.vue?vue&type=style&index=0&id=037d9437&lang=scss&module=true&scoped=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./alert.vue?vue&type=style&index=0&id=037d9437&lang=scss&module=true&scoped=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/runner/work/backOffice/backOffice/node_modules/vue-hot-reload-api/dist/index.js").rerender("037d9437")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "037d9437",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/backOffice/backOffice/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('037d9437')) {
      api.createRecord('037d9437', component.options)
    } else {
      api.reload('037d9437', component.options)
    }
    module.hot.accept("./alert.vue?vue&type=template&id=037d9437&scoped=true&", function () {
      api.rerender('037d9437', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/components/alert/alert.vue"
export default component.exports